var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M117.905 0H43.1666C15.9311 0 0.5 15.4311 0.5 42.6666V117.334C0.5 144.569 15.9311 160 43.1666 160H117.905C145.14 160 160.5 144.569 160.5 117.334V42.6666C160.5 15.4311 145.14 0 117.905 0Z",
    fill: "#B3B2B2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14604_136311)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.625 61.25H127.375C129.101 61.25 130.5 62.6491 130.5 64.375V76.875C130.5 78.6009 129.101 80 127.375 80H123.563L111.655 127.631C111.487 128.308 111.097 128.908 110.547 129.337C109.998 129.767 109.321 130 108.624 130H52.3741C51.6771 130 51.0001 129.767 50.4508 129.337C49.9016 128.908 49.5116 128.308 49.3429 127.631L37.4351 80H33.625C31.8991 80 30.5 78.6009 30.5 76.875V64.375C30.5 62.6491 31.8991 61.25 33.625 61.25Z",
    fill: "#B3B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5 117.5C79.6712 117.5 78.8763 117.171 78.2903 116.585C77.7042 115.999 77.375 115.204 77.375 114.375V95.625C77.375 94.7962 77.7042 94.0013 78.2903 93.4153C78.8763 92.8292 79.6712 92.5 80.5 92.5C81.3288 92.5 82.1237 92.8292 82.7097 93.4153C83.2958 94.0013 83.625 94.7962 83.625 95.625V114.375C83.625 115.204 83.2958 115.999 82.7097 116.585C82.1237 117.171 81.3288 117.5 80.5 117.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.875 117.5C64.0462 117.5 63.2513 117.171 62.6653 116.585C62.0792 115.999 61.75 115.204 61.75 114.375V95.625C61.75 94.7962 62.0792 94.0013 62.6653 93.4153C63.2513 92.8292 64.0462 92.5 64.875 92.5C65.7038 92.5 66.4987 92.8292 67.0847 93.4153C67.6708 94.0013 68 94.7962 68 95.625V114.375C68 115.204 67.6708 115.999 67.0847 116.585C66.4987 117.171 65.7038 117.5 64.875 117.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.125 117.5C95.2962 117.5 94.5013 117.171 93.9153 116.585C93.3292 115.999 93 115.204 93 114.375V95.625C93 94.7962 93.3292 94.0013 93.9153 93.4153C94.5013 92.8292 95.2962 92.5 96.125 92.5C96.9538 92.5 97.7487 92.8292 98.3347 93.4153C98.9208 94.0013 99.25 94.7962 99.25 95.625V114.375C99.25 115.204 98.9208 115.999 98.3347 116.585C97.7487 117.171 96.9538 117.5 96.125 117.5Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.125 42.5H64.875C65.7038 42.5 66.4987 42.8292 67.0847 43.4153C67.6708 44.0013 68 44.7962 68 45.625V61.25H43V45.625C43 44.7962 43.3292 44.0013 43.9153 43.4153C44.5013 42.8292 45.2962 42.5 46.125 42.5Z",
    fill: "#B3B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M71.125 30H89.875C90.7038 30 91.4987 30.3292 92.0847 30.9153C92.6708 31.5013 93 32.2962 93 33.125V61.25H68V33.125C68 32.2962 68.3292 31.5013 68.9153 30.9153C69.5013 30.3292 70.2962 30 71.125 30V30Z",
    fill: "#B3B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.125 36.25H114.875C115.704 36.25 116.499 36.5792 117.085 37.1653C117.671 37.7513 118 38.5462 118 39.375V61.25H93V39.375C93 38.5462 93.3292 37.7513 93.9153 37.1653C94.5013 36.5792 95.2962 36.25 96.125 36.25Z",
    fill: "#B3B2B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14604_136311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(30.5 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.aa181165d162e51fdf3500c6504cdf71.svg";
export { ForwardRef as ReactComponent };